import './badge.scss';

import { cn } from '@/shared/lib/utils';

type BadgeVariant = 'green' | 'amber' | 'gray';

type BadgeProps = {
  label: string;
  variant?: BadgeVariant;
  className?: string;
};

export function Badge({ label, variant = 'gray', className }: BadgeProps) {
  return (
    <span className={cn('badge', `badge--${variant}`, className)}>{label}</span>
  );
}
